<template>
<div class="tabs-content-wrapper">
    <div class="mobile-title c-text-card__title">{{ textCardTitle }}</div>
    <div class="c-tabs" v-if="tabs.length">
        <template v-for="(tab, index) in tabs" :key="index">
            <button
                class="c-tabs__btn_js"
                :disabled="!tab.isAvailable"
                :data-imprint_sku="tab.id"
                :class="[tab.isAvailable ? 'show_tab' : 'hide_tab', isComda ? 'c-tabs__btn__comda' : 'c-tabs__btn', store.selectedImprint.id === index ? ['c-tabs__btn--active', customBackground] : '']"
                @click="setActiveImprintTab(tab, index)"
            >
                {{ tab.tabName }}
            </button>
        </template>
    </div>

    <CustomSelect
        :options="tabs"
        :default="tabs[this.activeTabForCalendarBundle !== null ? this.activeTabForCalendarBundle : 0].tabName"
        class="select mobile"
        @updateTabsMobile="setActiveImprintTab"
    />

    <p class="message-calendar-titles" v-if="tabsCheckRequired && !availablePrintMethods.length">
        Unfortunately, one or more calendar titles in your bundle cannot be ordered together. Please remove one or more titles and try again.
    </p>

    <div class="c-tabs-content">
        <span> {{ tabs[activeTab].content }}</span>
    </div>
    <!-- Hide content section bottom, if imprint active tab hasn't content the section will empty
        <p v-if="store.application_type === 'calendar_single' || store.isCustomBundlePage" class="imprint-text calendar">
        Your products will be digitally printed in full {{ this.getColorText(true) }}. Please enter lines of
        text with your message, attach a logo or art file, or provide special instructions for your imprint.
        </p>
    -->
    <PriceMatrixComponent
      :applicationType = "applicationType" :isSpecial="isSpecial"/>
</div>
</template>

<script>
import {store} from './store';
import PriceMatrixComponent from './PriceMatrixComponent.vue';
import CustomSelect from './CustomSelect.vue';
import functions from "@/helpers/functions";
import { useAppStore } from '@/features/imprint/stores/useAppStore';

export default {
        emits:['tabs-status'],
        components: {
          PriceMatrixComponent, CustomSelect
        },
        props: {
          getColorText: Function,
          applicationType: String,
          textCardTitle: String,
        },
        data() {
            return {
                debugMode: true,
                activeTab: 0,
                tabs: [],
                store: store,
                full_product: {},
                tier_data: [], // type [{}]
                configurable_array: {},
                isMSRPData: false,
                MSRPPrice: null,
                key:null,
                imprintData:{},
                imprintSKUs: [],
                isSpecial: false,
                functions: functions,
                availablePrintMethods:[],
                activeTabForCalendarBundle:null
            }
        },
        computed: {
            customBackground() {
                return this.$getCustomBackgroundColorClass(store.storeID);
            },
            isComda() {
                return store.storeID.includes('comda');
            },
            tabsCheckRequired(){
                return  this.store.application_type === 'calendar'
            },
            appStore() {
                return useAppStore();
            },
        },
        methods: {
            setActiveImprintTab(tab, index) {
                console.warn("tab:");
                console.warn(tab);

                this.activeTab = index;
                this.store.selectedImprint.id = index;
                this.store.selectedImprint.tabName = tab.tabName;
                this.setTierData(tab.id);
                this.initImprintData();
                this.initFeePriceForTab();
                this.initSkuValueForTab();
                //this.initSpecialPrice();
                //this.isSpecial = Object.keys(this.store.specialPrice.byImprintMethods).includes(this.store.selectedImprint.sku);
                console.log("imprint Tabs data");
                console.log(this.store.selectedImprint.tabName);
                console.log(this.store.imprintKey);
                console.log(this.store.specialPrice);
                console.warn(this.isSpecial);
                if (this.store.application_type == 'calendar_single' || this.store.application_type == 'calendar') {
                    window.jQuery.event.trigger({
                        type: "imprintTabChanged",
                        message: "imprintTabChanged",
                        time: {tab: tab, index: index}
                    });
                }
            },
            initFeePriceForTab(){
                let imprintSKU = this.store.selectedImprint.sku;
                this.imprintData = this.store.inputProductData.fullJson.configurable_array[imprintSKU].configurable_2_data;
                this.store.selectedImprint.data = this.store.inputProductData.fullJson.configurable_array[imprintSKU];

                /*Fees data is empty for Calendar Envelop product.*/
                if(this.store.isEnvelopProduct && !Object.hasOwn(this.imprintData.imprint_data , 'setup_fee')) {
                    return;
                }

                // init store variables
                this.store.perItemFee.setupFee = this.imprintData.imprint_data.setup_fee;
                this.store.perItemFee.customColourFee = this.imprintData.imprint_data.custom_colour_fee;
                this.store.perItemFee.proof_fee = this.imprintData.imprint_data.proof_fee;
                this.store.perItemFee.image_fee = this.imprintData.imprint_data.image_fee;
                this.store.perItemFee.running_fee = this.imprintData.imprint_data.running_fee;
            },
            initSpecialPrice() {
                console.error("initSpecialPrice+++++");
                console.warn(this.store.selectedImprint.sku);
                let specialPriceObj = {
                    dateStart: null,
                    dateEnd: null,
                    value: null,
                    isImprintMethodSpecial: false,
                    tier: []
                }

                this.imprintSKUs = Object.keys(this.store.inputProductData.fullJson.configurable_array);
                this.imprintSKUs.forEach( sku => {
                    this.store.inputProductData.fullJson.configurable_array[sku].prices_2.tier_price.forEach(
                        (item,index) => {
                            console.warn("sdasdasdasdasd 121212");
                            console.log(this.store.prices.tier);
                            console.log(index);

                            const b2bTier = this.appStore.getB2BTierForSku(sku);
                            const b2bPrice = b2bTier !== null
                                ? this.functions.getB2BPriceForTier(item, b2bTier)
                                : null;
                            if (b2bPrice !== null) {
                                this.store.prices.priceByQty = b2bPrice;
                            } else if(
                                this.functions.isValidatedSpecialPrice(item)
                            ) {
                                this.isSpecial = Object.keys(this.store.specialPrice.byImprintMethods).includes(this.store.selectedImprint.sku);
                                if(this.store.prices.tier) {
                                    this.store.prices.tier[index]['is_special_tier'] = this.functions.isCurrentDateActive(
                                        item['sale_price_effectivedate'],
                                        item['sale_price_terminationdate']
                                    );

                                }
                                specialPriceObj.dateStart = item['sale_price_effectivedate'];
                                specialPriceObj.dateEnd = item['sale_price_terminationdate'];
                                specialPriceObj.value = item['sale_price'];
                                specialPriceObj.tier.push({
                                    index: index,
                                    value: item['sale_price']
                                });
                                this.store.specialPrice.byImprintMethods[sku] = specialPriceObj;
                                Object.assign(this.store.specialPrice, specialPriceObj);
                                this.store.prices.priceByQty = item['sale_price'];
                            } else {
                                if(this.store.prices.tier) {
                                    this.store.prices.tier[index]['is_special_tier'] = false;
                                }
                                this.store.prices.priceByQty = item['price'];
                            }
                            if(this.store.prices.tier) {
                                console.error("isCurrentDateActive vvvvvv ");
                                console.error("qqqqqqqqqqqqqqqq");
                                console.error(this.store.prices.tier[index]['is_special_tier']);
                                console.log(this.store.prices.tier[index]['is_special_tier']);
                            }
                        }
                    );
                });


            },
            initSkuValueForTab(){
                // init var for CartLine properties
                this.store.sku.fee.custom_colour_fee.val = this.imprintData.imprint_data.colour_fee_sku;
                this.store.sku.fee.image_fee.val = this.imprintData.imprint_data.image_fee_sku;
                this.store.sku.fee.proof_fee.val = this.imprintData.imprint_data.proof_fee_sku;
                this.store.sku.fee.running_fee.val = this.imprintData.imprint_data.running_fee_sku;
                this.store.sku.fee.setup_fee.val = this.imprintData.imprint_data.setup_fee_sku;
                this.store.sku.imprint.method.val = this.store.selectedImprint.sku;
            },
            setImprintKey() {
                this.store.imprintKey = this.store.selectedImprint.tabName;
            },
            initImprintData() {
                this.setImprintKey();
                if (!Object.hasOwn(this.store.colorSizeLines, this.store.imprintKey)) {
                    /*STEP 2*/
                    this.store.colorSizeLines[this.store.imprintKey] = [];
                    let colorSizeLines = {
                        slectedColor: {
                            id: null,
                            title: '',
                            img_src: '',
                            img_id: '',
                            sku: ''
                        },
                        /* same to variable sizesQty  ex.: {2XL:1}*/
                        selectedSizes: {},
                    };
                    this.store.colorSizeLines[this.store.imprintKey].push(colorSizeLines);

                    this.store.selectedColorsList[this.store.imprintKey] = [];
                    /*STEP 2 END */
                    this.store.selectedLastStep[this.store.imprintKey] = {};
                    let selectedLastStep = {
                        imprintLocation: '',
                        _imprintLocation: {
                            value: null,
                            sku: null
                        },
                        uploaded_image: null,
                        special_instruction: null,
                        imprintTypeID: 1,
                        lines: [],
                        uniqueColors: [],
                        uniqueColorsCount: 0,
                        stepId: null,
                        messageUpload: null
                    }
                    this.store.selectedLastStep[this.store.imprintKey] = selectedLastStep;

                    this.store.imprintMessageColorLines[this.store.imprintKey] = [];
                    let imprintMessageColorLines =
                        {
                            id: 0, // //countLines,not sure if need, investigation and improvenment
                            label: 'Line',
                            selectedColor: null, //this.applayToAll.selectedColor !== null ? this.applayToAll.selectedColor : null,
                            selectedColorObj: null,
                            custommColor: false,
                            isImageLine: false,
                            lineMessage: '',
                            colors: [],
                            isOpenedColorsPantoneWrapp: 0,
                            type: "message"
                        };
                    this.store.imprintMessageColorLines[this.store.imprintKey].push(imprintMessageColorLines);
                }

                console.log(this.store);
                console.log("STORE !!!!!!!!!!! Imprint Tab");
            },
            getAvailableMethods(configurableArray, selectedSkus) {
                const available = [];

                Object.keys(configurableArray).forEach(methodKey => {
                    const method = configurableArray[methodKey];
                    // const methodSKUs = Object.keys(method.simple_array);
                    const methodSKUs = method.associated_sku.map(item => item.sku);

                    const allPresent = selectedSkus.every(sku =>
                        methodSKUs.includes(sku)
                    );

                    if (allPresent) {
                        available.push(methodKey);
                    }
                });

                return available;
            },
            getImprintHtml() {
                let availablePrintMethods = [];

                if(this.tabsCheckRequired){
                    this.initCalendarSku();
                    const selectedSkus = this.store.calendar.productList.map(item => item.calendar_sku);
                    availablePrintMethods =  this.getAvailableMethods(this.full_product.configurable_array,selectedSkus);
                    this.availablePrintMethods = availablePrintMethods
                    console.log('--calendar selected Skus and available methods--');
                    console.log(selectedSkus);
                    console.log(availablePrintMethods);
                }

                for(let key in this.full_product.configurable_array) {
                    console.log(this.full_product.configurable_array[key].imprint_description);
                    console.log(key);
                    let  isAvailable = true;

                    if(this.tabsCheckRequired){
                        isAvailable = availablePrintMethods.includes(key);
                    }
                        this.tabs.push(
                            {
                                id: key,
                                tabName: this.full_product.configurable_array[key].name,
                                content: this.full_product.configurable_array[key].imprint_description !== undefined ? this.full_product.configurable_array[key].imprint_description : "",
                                priceSort: Number(this.full_product.configurable_array[key].prices_2.min_price),
                                isAvailable: isAvailable
                            }
                        );
                    console.log('min-price ' + key + ' '+ Number(this.full_product.configurable_array[key].prices_2.min_price));
                }

              this.tabs.sort(function (a, b) {
                if (a.priceSort > b.priceSort) {
                  return 1;
                }
                if (a.priceSort < b.priceSort) {
                  return -1;
                }

                return 0;
              });

              if (this.tabsCheckRequired) {
                  this.activeTabForCalendarBundle = this.tabs.findIndex(item => item.isAvailable);

                  if (this.activeTabForCalendarBundle == '-1') {
                      this.activeTabForCalendarBundle = null;
                  }

                  this.$emit('tabs-status', this.activeTabForCalendarBundle);
                  console.log("activeTabForCalendarBundle - " + this.activeTabForCalendarBundle);
                }

               console.log(">>>>>>>>>>>>>>>>> TABS:");
                console.log(this.tabs);
                console.log(this.activeTab);

            },
            getFullProductJson() {
                if(this.store.inputProductData.fullJson) {
                    this.full_product = this.store.inputProductData.fullJson;
                } else {
                    this.full_product = JSON.parse(document.getElementById("full_product_info_json").textContent);
                    this.store.inputProductData.fullJson = this.full_product;
                }
                console.warn("-----> Start Full Json // ImprintTabs.vue");
                console.log(this.full_product);
                console.warn("-----> End Full Json");
            },
            setTierData(sku) {
                console.warn("setTierData");
                console.log(sku);
                console.log(this.full_product.configurable_array[sku]);

                //TODO when return from step 2 to 1 not inited this.isSpecial
                // ned to improve
                this.initSpecialPrice();
                this.isSpecial = Object.keys(this.store.specialPrice.byImprintMethods).includes(this.store.selectedImprint.sku);
                console.log("imprint Tabs data setTierData");
                console.log(this.store.selectedImprint.tabName);
                console.log(this.store.imprintKey);
                console.log(this.store.specialPrice);
                console.warn(this.isSpecial);

                let attribute = null;
                let upcharge = null;
                let colorUpcharge = null;

                this.store.selectedImprint.sku = sku;
                this.tier_data = this.store.inputProductData.fullJson.configurable_array[sku]["prices_2"].tier_price;
                this.store.prices.tier = this.tier_data;
                this.store.prices.b2bTier = this.appStore.getB2BTierForSku(sku);

                this.addMSRPproperty();
                this.initMapFullSizeNameToShort();

                if(this.store.selectedImprint.sku) {
                    let imprintData = this.full_product.configurable_array[sku].configurable_2_data;

                    console.error("%%%%%%%%%%%%%%% this.store.application_type mmmmmmmmmmmmmmmmmmmmmmmmmm");
                    console.warn(this.store.application_type);

                        let singleCalendarBundleTag = '';
                        console.log(document.getElementById("it-is-bundle-product"));
                        if(document.getElementById("it-is-bundle-product")) {
                            singleCalendarBundleTag = document.getElementById("it-is-bundle-product").textContent;
                            console.log(singleCalendarBundleTag);
                            console.warn(singleCalendarBundleTag == 'yes');
                        }
                    if(this.store.application_type == "default") {

                        if(singleCalendarBundleTag == 'yes') {
                            this.store.application_type = 'calendar_single';
                        }
                    }
                    if (this.store.application_type !== "calendar" && singleCalendarBundleTag !== 'yes') {
                        attribute = this.full_product.configurable_array[sku].attribute;
                        console.warn("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&  Attribute &&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&");
                        console.log(attribute);
                        console.log(this.store.storeID);

                        if (attribute.length == 1) {
                          colorUpcharge = attribute[0].code == 'color' ? attribute[0].upcharge : null;
                        } else if (attribute.length == 2) {
                          upcharge = attribute[1].code == 'size' ? attribute[1].upcharge : null;
                          colorUpcharge = attribute[0].code == 'color' ? attribute[0].upcharge : null;
                        }
                        console.warn("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&  Size Upcharge &&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&");
                        console.log(upcharge);
                        console.warn("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&  Color Upcharge &&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&");
                        console.log(colorUpcharge);
                    }
                    // Set proof_fee
                    /*For Calendar Envelop product fee data is missing in full json (imprint_data) */
                    if(Object.hasOwn(this.imprintData,'imprint_data')
                        && Object.hasOwn(this.imprintData.imprint_data , 'setup_fee')
                        && Object.hasOwn(this.imprintData.imprint_data , 'proof_fee'))
                    {
                        this.store.perItemFee.proof_fee = imprintData.imprint_data.proof_fee;
                        this.store.perItemFee.setupFee = imprintData.imprint_data.setup_fee;
                    }
                    // TODO improve duplicated code
                    if(!upcharge) {
                        console.error(" >>>> attribute upcharge not found /ImprintTabs/setTierData <<<<");
                    } else {
                        let result = {};
                        upcharge.forEach(
                            item => {
                                if(item.store == this.store.storeID) {
                                    result[item.option] = item.price;
                                }
                            }
                        );

                        this.store.inputProductData.sizeUpcharge = result;
                    }

                    if(!colorUpcharge) {
                        console.error(" >>>> attribute upcharge not found /ImprintTabs/setTierData <<<<");
                    } else {
                        let result = {};
                        colorUpcharge.forEach(
                            item => {
                                if(item.store == this.store.storeID) {
                                    let label = item.option.toLowerCase();
                                    result[label] = {
                                      price: item.price,
                                      price_type: item.price_type
                                    }
                                }
                            }
                        );

                        this.store.inputProductData.colorUpcharge = result;
                    }

                }

                if(this.store.application_type == "calendar") {
                    this.initCalendarSku();
                } else {
                    console.error("Imprint tabs aplication_type not ''``" + this.store.application_type);
                }

                console.warn("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&   this.store.inputProductData.sizeUpcharge &&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&");
                console.log(this.store.inputProductData.sizeUpcharge);

                console.warn("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&   this.store.inputProductData.colorUpcharge &&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&");
                console.log(this.store.inputProductData.colorUpcharge);

                this.$emit("imprintTierSeted", this.store.perItemFee);
                console.error(">>>>>>>>>>> setTierData >>>>>>>>>");
                console.log(this.tier_data);
            },
            initCalendarSku() {
                console.error(">>>> initCalendarSku <<<<");
                console.warn(this.store.calendar.productList);

                if(this.store.calendar.productList.length) {
                    this.store.calendar.productList.forEach( (item,index) => {
                        console.warn(item);
                        console.warn(index);
                        console.warn(index);
                        this.store.calendar.productList[index]['calendar_sku'] = this.store.inputProductData.fullJson.simple_attributes.calendar_sku[item.title.trim()];
                    });
                }
            },
            initMapFullSizeNameToShort() {
                let simples = this.store.inputProductData.fullJson.configurable_array[this.store.selectedImprint.sku].simple_array;
                for (const propName in simples) {
                    if(!Object.keys(this.store.fullSizeNameToShort).length && simples[propName].size != simples[propName].sku_size_code) {
                        this.store.fullSizeNameToShort[simples[propName].size] = simples[propName].sku_size_code;
                        console.error(">>> !!! Loop length 00000 ");
                        console.log(this.store.fullSizeNameToShort);
                    } else if (!Object.hasOwn(this.store.fullSizeNameToShort, simples[propName].size)) {
                        this.store.fullSizeNameToShort[simples[propName].size] = simples[propName].sku_size_code;
                        console.error(">>> !!! Loop 'If property' build data full size name to short ");
                        console.log(this.store.fullSizeNameToShort);
                    }
                }
            },
            addMSRPproperty() {
                let curSKU = this.store.selectedImprint.sku;

                if(this.full_product.configurable_array[curSKU].prices_2.msrp && this.tier_data[0].QtyMin !== 'MSRP') {
                  this.MSRPPrice = this.full_product.configurable_array[curSKU].prices_2.msrp;
                  this.store.prices.tierMSRP = this.MSRPPrice;
                }

                console.error("------------------Curren tier data ---------------");
                console.log(this.tier_data);
                console.error("------------------MSRPPrice ---------------");
                console.log(this.MSRPPrice);
            },
            initQtyIncriment() {
                if(this.debugMode && this.store.selectedImprint.sku == null) {
                    console.error("check selectedImprint.sku");
                }

                this.store.inputProductData.qtyIncrement = this.full_product.configurable_array[this.store.selectedImprint.sku].qty_increment;
                if(this.store.application_type == 'calendar' || this.store.application_type == 'calendar_single') {
                    if(localStorage.getItem("storageProductList") !== null) {
                    let bundleProducts = JSON.parse(localStorage.storageProductList);
                    let bundleTotalQty = 0;
                    if(bundleProducts.length && bundleTotalQty == 0) {
                        bundleProducts.forEach( product => {
                            bundleTotalQty = bundleTotalQty + parseInt(product.qty);
                        });
                    }
                    this.store.totalSizesQty[this.store.imprintKey] = bundleTotalQty;
                    this.store.inputProductData.minOrderQty = this.isComda ? 100 : 150;//150 in bundle applications
                        /* TODO change logic in calendar bundle application for initializing minBundleQty.
                            For comda calendar min order quantity is 100 in configurable_array[this.store.selectedImprint.sku].min_order_qty property
                            rather then 150 for mlp*/
                    }
                } else {
                    this.store.inputProductData.minOrderQty = this.full_product.configurable_array[this.store.selectedImprint.sku].min_order_qty;
                }

                if(this.debugMpode && this.store.inputProductData.qtyIncrement == null) {
                    console.error("check initQtyIncriment() ImprintTabs component");
                    /* default qtyIncrement if null*/
                    this.store.inputProductData.qtyIncrement = 1;
                }

                if(this.debugMode && this.store.inputProductData.minOrderQty == null) {
                    console.error("check minOrderQty ImprintTabs component");
                    /* set by default 100 */
                    this.store.inputProductData.minOrderQty = 100;
                }

                if(this.store.minOrderQty > 1 && this.store.qtyIncrement >= 1 ) {
                    this.$emit("initedQtyIncrement", this.store.inputProductData.minOrderQty);
                }

                /* Logs if debugMode == true */
                if(this.debugMpode) {
                    console.log(this.store.selectedImprint.sku);
                    console.log(this.full_product.configurable_array[this.store.selectedImprint.sku].qty_increment);
                    console.error("End init Incriment");
                }
            }
        },

        created() {
            console.error("Created ImprintTabs");
            this.getFullProductJson();

            this.getImprintHtml();

            let indexActiveTab = this.activeTabForCalendarBundle !== null ? this.activeTabForCalendarBundle : 0;
            console.log("indexActiveTab -- ");
            console.log(indexActiveTab);

            if(this.store.selectedImprint.id === null ) {
                this.setActiveImprintTab(this.tabs[indexActiveTab], indexActiveTab);
            }
            if(this.store.selectedImprint.sku === null) {
                this.setTierData(this.tabs[indexActiveTab].id);
            } else {
                this.setTierData(this.store.selectedImprint.sku);
            }
            if(this.store.selectedImprint.sku !== null) {
                console.error("init Incriment");
                this.initQtyIncriment();
            }

            if(window.jQuery("#calendar-qty-changed")) {
                window.jQuery("body").on("click","#calendar-qty-changed",
                    (event)=> {
                        console.log(event);
                        console.warn("ImprintTabs qty created hook ");
                        if(window.jQuery("#calendar-imprint-common-qty")) {
                            console.error(window.jQuery("#calendar-imprint-common-qty").val());
                            //let value = window.jQuery("#calendar-imprint-common-qty").val();
                                if(this.store.selectedImprint.id === null ) {
                                    this.setActiveImprintTab(this.tabs[0], 0);
                                }
                                if(this.store.selectedImprint.sku === null) {
                                    this.setTierData(this.tabs[0].id);
                                } else {
                                    this.setTierData(this.store.selectedImprint.sku);
                                }
                                if(this.store.selectedImprint.sku !== null) {
                                    console.error("init Incriment");
                                    this.initQtyIncriment();
                                }
                        }
                    }
                );
            }
        }
    }


</script>

<style>
.c-tabs {
  padding: 20px 0 15px 0;
}
.c-tabs {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.c-tabs__btn {
  font-family: 'museo-sans', sans-serif;;
  display: inline-block;
  width: 45%;
  max-width: 45%;
  font-size: 12px;
  line-height: 14px;
  border: 1px solid #707070;
  border-radius: 5px;
  padding: 5px 0;
  background-color: #fff;
  font-weight: 300;
  color: #595959;
  cursor: pointer;
  margin-right: 6px;
}
.c-tabs__btn__comda {
    display: inline-block;
    width: 45%;
    max-width: 45%;
    font-family: "Open Sans",serif;
    font-size: 11px;
    line-height: 14px;
    border: 2px solid #d7d7d7;
    border-radius: 7px;
    padding: 2px 15px;
    background-color: #fff;
    font-weight: 700;
    color: #595959;
    cursor: pointer;
    margin-right: 6px;
}
.c-tabs__btn--active {
  color: #fff;
  font-weight: 700;
 }
.c-tabs-content {
  line-height: 18px;
  font-size: 12px;
  color: #5A5A5A;
  font-weight: 300;
  text-align: left;
  padding-bottom: 15px;
}
.imprint-text.calendar{
  padding-top: 0;
}

@media only screen and (max-width: 768px) {
    .c-tabs{
        display: none;
    }
}

.c-tabs__btn_js.hide_tab{
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events:none;
}

.message-calendar-titles{
    color: #E83223;
}
</style>